module.exports = __webpack_public_path__ + "img/Walnussstrasse.d586f174.jpg";